import "./base.js";

// This will be used to contain the slot information

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.Slot = class Slot extends AppointmentBooking.SlotSuggester.Models.Base {
  defaults() {
    return {
      id: null,
      startTime: null,
      providerType: null,
      providerId: null,
      address: {},
    };
  }
};

AppointmentBooking.SlotSuggester.Models.Slot.prototype.relations = [
  {
    type: Backbone.HasOne,
    key: "provider",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Provider",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Providers",
  },
];

AppointmentBooking.SlotSuggester.Models.Slot.get("startMoment", function () {
  return moment.parseZone(this.get("startTime"));
});
